import { TDocumentDefinitions } from "pdfmake/interfaces";
import getFooter from "report/common/footer";
import gap from "report/common/gap";
import getHeader from "report/common/header";
import getLogo from "report/common/logo";
import getMap from "report/common/map";
import scenario from "report/crs/appendix/scenario";
import score from "report/crs/appendix/score";
import getReportGEO from "report/crs/detail/geo";
import getLayer from "report/crs/detail/layer";
import getReportDetail from "report/crs/detail/report";
import getData from "report/crs/table/data";
import {
  ClimateRiskReportSection,
  isColorlessClimateRiskCategory
} from "./types";
import title from "report/common/title";
import { info } from "report/common/meta";
import page from "report/common/page";
import getTpye from "report/common/type";

interface Param {
  t: any;
  name: string;
  lng: number;
  lat: number;
  province: string;
  county: string;
  sections: ClimateRiskReportSection[];
}

const getDoc = async ({
  t,
  name,
  lng,
  lat,
  province,
  county,
  sections
}: Param): Promise<TDocumentDefinitions> => {
  const legendSections = sections.filter(
    (section) => !section.isEmpty && section.sspData.SSP126Arr.length > 0
  );
  const lastSection = sections[sections.length - 1];
  const shouldInsertAppendixPageBreak =
    !!lastSection &&
    !lastSection.isEmpty &&
    isColorlessClimateRiskCategory(lastSection.category);

  const docDefinition: TDocumentDefinitions = {
    pageMargins: [20, 60, 20, 30],

    header: (currentPage, pageCount) =>
      currentPage === 1 ? getHeader(t("report.CatNet")) : getLogo(),

    footer: (currentPage, pageCount) => getFooter(t, currentPage, pageCount),

    content: [
      {
        columns: [
          {
            stack: getReportDetail(t, name, lng, lat)
          },
          {
            stack: getReportGEO(t, province, county)
          }
        ],
        columnGap: 20,
        margin: [0, 20, 0, 10]
      },
      {
        columns: [
          {
            stack: await getMap(t("report.Map View"))
          },
          {
            stack: legendSections.length ? getLayer(t, legendSections) : []
          }
        ],
        columnGap: 20,
        pageBreak: "after"
      },

      ...sections.flatMap((section) => {
        const sectionContent = [getTpye(section.title), gap(20)];

        if (section.description) {
          sectionContent.push({
            text: section.description,
            margin: [0, 0, 0, 8],
            opacity: 0.7
          });
        }

        // Handle empty section
        if (section.isEmpty) {
          return [
            ...sectionContent,
            {
              text: t(section.emptyReason || "report.crsSectionEmptyDesc"),
              margin: [0, 40, 0, 0],
              alignment: "left",
              fontSize: 10,
              opacity: 0.7
            } as any,
            page()
          ];
        }

        // Handle normal section with data
        return [
          ...sectionContent,
          ...getData(
            t,
            section.sspData.SSP126Arr,
            section.sspData.SSP245Arr,
            section.sspData.SSP370Arr,
            section.sspData.SSP585Arr,
            section.category
          )
        ];
      }),

      ...(shouldInsertAppendixPageBreak ? [page()] : []),

      title(t("appendix.title")),

      ...scenario(t),

      ...score(t)
    ],

    info: info,

    defaultStyle: {
      // font: getLanguage() === "en" ? "Roboto" : "微软雅黑",
      font: "普惠体",
      fontSize: 8,
      // opacity: 0.6,
      lineHeight: 1,
      characterSpacing: 0
    },
    styles: {
      header: {
        alignment: "center",
        fontSize: 13,
        bold: true
        // marginBottom: 10
      },
      headerCell: {
        alignment: "center",
        // padding: [5, 5, 5, 5],
        bold: true,
        fillColor: "#006D73",
        color: "#ffffff",
        margin: [10, 10, 10, 10],
        fontSize: 10
      },
      bodyText: {
        fontSize: 10
        // padding: [5, 5, 5, 5]
      },
      // 单元格样式定义
      defaultCellStyle: {
        fontSize: 10,
        bold: true
      }
    }
  };

  return docDefinition;
};

export default getDoc;
